"use client";

import {
	InteractiveMediaBarsTrack,
	MEDIA_PLAYER_CARD_SEEK_TRACK_HEIGHT_PX,
	TOPIC_LEARN_SCRUB_THUMB_DIAMETER_PX,
} from "../custom/interactive-media-player/interactive-media-bars-track";
import type { MediaPlayerSeekSegment } from "./media-player-seek-bar";
import type { MediaPlayerTheme } from "./media-player-theme";

export {
	MEDIA_PLAYER_CARD_SEEK_TRACK_HEIGHT_PX,
	TOPIC_LEARN_SCRUB_THUMB_DIAMETER_PX,
};

export interface MediaPlayerCardSeekBarProps {
	theme: MediaPlayerTheme;
	value: number;
	maxSeekPercent: number;
	/**
	 * Continuation timer progress (0–100), shown as a translucent fill behind
	 * the playhead. Omit when not tracking continuation on this track.
	 */
	continuationPercent?: number;
	furthestConsumedPercent?: number;
	roundedFull?: boolean;
	/** Renders a circular thumb at the playhead (topic layouts). */
	showThumb?: boolean;
	/**
	 * White circle + caret pin at the playhead (narrow edge scrub).
	 * Fades in while scrubbing; fades out after release delay.
	 */
	showSeekPin?: boolean;
	/** Keep the pin visible as the persistent playhead. */
	seekPinAlwaysVisible?: boolean;
	/** Delay after scrub release before the seek pin fades out. */
	seekPinHideDelayMs?: number;
	/** Thumb diameter in px; should exceed track height when enlarged. */
	thumbDiameterPx?: number;
	thumbClassName?: string;
	/** Vertical markers + hover labels for topic timeline segment boundaries. */
	segments?: MediaPlayerSeekSegment[];
	interactive: boolean;
	/** Soft aurora glow behind the track (default on for learner media players). */
	trackGlow?: boolean;
	onPause: () => void;
	onSeekCommit: (percent: number) => void;
	onSeekRejected?: () => void;
	className?: string;
	"aria-label"?: string;
}

export function MediaPlayerCardSeekBar(props: MediaPlayerCardSeekBarProps) {
	return <InteractiveMediaBarsTrack {...props} />;
}
